import React from 'react';
import { Loader } from '@helloworld1812/app-global-components';

import type { FullHeightWrapperWithLoaderProps } from './full-height-wrapper-with-loader.types';
import { S } from './full-height-wrapper-with-loader.styles';

export function FullHeightWrapperWithLoader({
  children,
  fullScreen = true,
  spinning = false,
  showLoader = true,
}: FullHeightWrapperWithLoaderProps) {
  if (!showLoader) return children;

  return (
    <S.FullHeightWrapper>
      <Loader fullScreen={fullScreen} spinning={spinning} />
      {children}
    </S.FullHeightWrapper>
  );
}
